/**!
 * Created by Leonardo Cheslacki on 27/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import HelpersController from './HelpersController';

import VARIABLES from './../../../../variables.json';

import WithType from './WithType';

import {HelpersPin} from './';

let _this = {};

/**
 *
 */
class HelpersIcon extends HelpersController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        const {current_name} = this.props;

        this.$helpersPin = HelpersPin(this)({current_name: current_name});

        _this = this;
    };

    /**
     *
     * @param occ_align
     * @param color
     * @param occ_icon
     */
    setColor = (occ_align, color, occ_icon = '') => {
        if (this.isTintColor(color)) {
            this.$helpersPin.setColor(this.verifyField(occ_align, 'occ_effect.occ_round'), color);
            this.$helpersPin.setColor(this.verifyField(occ_align, 'occ_effect.occ_animate.occ_round_first'), color);
            this.$helpersPin.setColor(this.verifyField(occ_align, 'occ_effect.occ_animate.occ_round_second'), color);
            !this.isEmpty(occ_icon) && this.$helpersPin.setColor(this.verifyField(occ_align, occ_icon), color);
        }
    };

    /**
     *
     * @param _this
     * @param color
     * @param occ
     */
    setIcon = (_this, color = null, occ = false) => {

        for (let property of VARIABLES.icon) {
            let occ_icon = this.verifyField(_this, `occ_icon_${property}`);

            if (occ_icon) {
                if (property === 'more') {
                    for (let property_more of VARIABLES.icon) {
                        (property_more !== 'none') && (occ_icon[`occ_${property_more}`].visible = (property_more === 'more'));
                    }
                } else if (property === 'none') {
                    for (let property_none of VARIABLES.icon) {
                        (property_none === 'none') && (occ_icon[`occ_${property_none}`].visible = false);
                    }
                } else {
                    occ_icon.occ_more.visible = false;
                    occ_icon[`occ_${property}`].visible = true;
                }

                !this.isEmpty(color) && this.setColor(occ_icon, color, (property !== 'none') ? `occ_${property}` : '');
            }
        }

        if (occ) {
            let
                pad_number = this.padWithLeadingZeros(occ, 2),
                occ_icon_frame = this.verifyField(_this, `occ_icon_frame${pad_number}`),
                occ_icon_page = this.verifyField(_this, `occ_icon_page${pad_number}`),
                occ_icon_pav = this.verifyField(_this, `occ_icon_pav${pad_number}`);

            if (occ_icon_frame) {
                !this.isEmpty(color) && this.setColor(occ_icon_frame, color, 'occ_more');
            }

            if (occ_icon_page) {
                !this.isEmpty(color) && this.setColor(occ_icon_page, color, 'occ_more');
            }

            if (occ_icon_pav) {
                !this.isEmpty(color) && this.setColor(occ_icon_pav, color, 'occ_more');
            }
        }
    };

    /**
     *
     * @param _this
     * @returns {(function(*, boolean=): void)|*}
     */
    disabledAnimate = (_this) => (occ, name = 'page') => {

        for (let property of VARIABLES.icon) {
            let occ_icon = this.verifyField(_this, `occ_icon_${property}`);
            occ_icon && (occ_icon.occ_effect.occ_animate.visible = !(occ === property));
        }

        let
            pad_number = this.padWithLeadingZeros(occ, 2),
            occ_icon = this.verifyField(_this, `occ_icon_${name}${pad_number}`);

        if (occ_icon) {
            occ_icon.occ_effect.occ_animate.visible = false;
        }
    };
}

/**
 *
 * @type {{}}
 */
HelpersIcon.propTypes = {};

/**
 *
 * @type {{}}
 */
HelpersIcon.defaultProps = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersIcon, {className: 'HelpersIcon'});
